import items from './items'

export default {
  postForgotPassword(email) {
    return items.createItem('auth/forgot_password', { email })
  },
  logout() {
    return items.getItem('auth/logout')
  },
  isAuthenticated() {
    const customer = process.env.CUSTOMER || process.env.customer
    return customer === 'motelone' ? items.getItem('user/me') : items.getItem('auth/is_authenticated')
  },
}
